var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAssetManagementDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11V16.6726H28.5C29.0523 16.6726 29.5 17.1203 29.5 17.6726V22.3452C29.5 22.8975 29.0523 23.3452 28.5 23.3452L21.5 23.3451L13.6821 23.3452H7C6.44772 23.3452 6 22.8975 6 22.3452V16.6726V11.0001C6 10.4478 6.44772 10 7 10H13.6821L20.5 10C21.0523 9.99999 21.5 10.4477 21.5 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.3451V16.6726M21.5 23.3451L28.5 23.3452C29.0523 23.3452 29.5 22.8975 29.5 22.3452V17.6726C29.5 17.1203 29.0523 16.6726 28.5 16.6726H21.5M21.5 23.3451L13.6821 23.3452M21.5 16.6726V11C21.5 10.4477 21.0523 9.99999 20.5 10L13.6821 10M21.5 16.6726H13.6821M13.6821 23.3452H7C6.44772 23.3452 6 22.8975 6 22.3452V16.6726M13.6821 23.3452V16.6726M13.6821 10H7C6.44772 10 6 10.4478 6 11.0001V16.6726M13.6821 10V16.6726M13.6821 16.6726H6",
    stroke: "#92A1B6",
    strokeOpacity: 0.631373,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7023 21.6069L36.1525 22.8931C35.9951 23.2612 35.6332 23.5 35.2329 23.5H9.95689C9.43062 23.5 8.98843 23.909 9.00445 24.435C9.10017 27.5779 10.7355 29.8176 11.6174 31.0612L10.7026 34.7599C10.5467 35.3905 11.0238 36 11.6733 36H36.6305C37.0933 36 37.4955 35.6825 37.6031 35.2323L38.5995 31.0612L41.5538 22.3202C41.7729 21.6719 41.2908 21 40.6064 21H37.6217C37.2213 21 36.8597 21.2388 36.7023 21.6069Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17249 31L4.07215 34.7161C3.88239 35.357 4.36263 36 5.031 36H35.694C36.1404 36 36.5327 35.7042 36.6555 35.275L37.8781 31M5.17249 31C4.1009 29.7378 2.11145 27.4622 2.00453 24.2679C1.9871 23.747 2.42802 23.3452 2.94921 23.3452H33.9859C34.3613 23.3452 34.7051 23.135 34.8761 22.8008L35.6143 21.3586C35.7853 21.0244 36.1291 20.8142 36.5045 20.8142H40.5166C41.2257 20.8142 41.7096 21.5319 41.4435 22.1893L37.8781 31M5.17249 31H27.5M37.8781 31H33.5",
    stroke: "#92A1B6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetManagementDisabled);
export default __webpack_public_path__ + "static/media/icon-asset-management-disabled.cf166cdb6fdd83e4f5068fdf8809bfcf.svg";
export { ForwardRef as ReactComponent };